/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../app/dialog/dialog.actions';
import { SubmitButton } from '../../pages/common/forms/SubmitButton';
import { ConnectedDialog } from '../ConnectedDialog';
import { SupportForm } from '../../pages/common/forms/SupportForm';

export const SupportDialog: FunctionComponent = () => {
  const dispatch = useDispatch();

  const onClose = useCallback(() => {
    dispatch(closeDialog('supportDialog'));
  }, [dispatch]);

  return (
    <ConnectedDialog dialogKey="supportDialog">
      <div>
        <div className="panel w500">
          <div className="panel-header small-header flex jcsb">
            <h3 className="f-2">Contact Support</h3>
            <span className="close-popup close" onClick={onClose}>
              <i className="icon-close" />
            </span>
          </div>
          <div className="panel-body">
            <SupportForm />
          </div>
          <div className="panel-footer no-border flex jcr">
            <a className="link blueGray mr-2 close" onClick={onClose}>
              Cancel
            </a>
            <SubmitButton apiKey="submitSupportRequest" formName="support-form" text="Send" color="##1BC3A7" />
          </div>
        </div>
      </div>
    </ConnectedDialog>
  );
};
